const PREFIX = 'PARTS_',
SET = 'SET_';

/**
 * @name APPLY_HASH_CHANGE
 * @const
 * @description Applies hash values to parts
 */
export const APPLY_HASH_CHANGE = PREFIX + 'APPLY_HASH_CHANGE';

/**
* @name RESET_PART
* @const
* @description Resets parts to default parameters
*/
export const RESET_PARTS = PREFIX + 'RESET_PARTS';

/**
 * @name SELECT_PART
 * @const
 * @description Selects a specific part
 */
export const SELECT_PART = PREFIX + 'SELECT_PART';

/**
 * @name SET_PAGE
 * @const
 * @description Applies the page to the visible parts
 */
export const SET_PAGE = PREFIX + SET + 'PAGE';

/**
 * @name SET_PAGE_SIZE
 * @const
 * @description Applies the page size to the visible parts
 */
 export const SET_PAGE_SIZE = PREFIX + SET + 'PAGE_SIZE';

/**
 * @name SET_PARTS
 * @const
 * @description Applies the parts to the table
 */
export const SET_PARTS = PREFIX + SET + 'PARTS';

/**
 * @name SET_POPUP
 * @const
 * @description Selects a specific part to display in the popup
 */
export const SET_POPUP = PREFIX + SET + 'POPUP';